module.exports = __webpack_public_path__ + "static/audemarspiguet-a82e250c0baabde369a76dcc54b92cee.png";